import { Link } from "react-router-dom";
import { Container, PageHeader } from "@/components/site/PageHeader";
import { LEGAL_PAGES } from "@/lib/legal";

const linkCls = "text-white underline decoration-primary decoration-2 underline-offset-4 hover:text-primary transition-colors";

const Line = ({ line }) => {
  if (typeof line === "string") return <p className={line.startsWith("[") ? "text-primary font-bold" : ""}>{line}</p>;
  if (line.email) return <p>{line.label} : <a href={`mailto:${line.email}`} className={linkCls} data-testid={`legal-email-${line.email.split("@")[1].split(".")[0]}`}>{line.email}</a></p>;
  return <p><a href={line.href} target="_blank" rel="noreferrer" className={linkCls} data-testid="legal-registry-link">{line.label}</a></p>;
};

const Section = ({ s, i }) => (
  <section className="grid md:grid-cols-[80px_1fr] gap-4 md:gap-10 py-10 border-b border-white/10" data-testid={`legal-section-${i}`}>
    <span className="font-display text-3xl text-primary">{String(i + 1).padStart(2, "0")}</span>
    <div>
      <h2 className="font-display uppercase text-2xl md:text-3xl text-white mb-4">{s.title}</h2>
      <div className="space-y-3 text-zinc-300 text-sm sm:text-base leading-relaxed max-w-3xl">
        {s.lines.map((l, j) => <Line key={j} line={l} />)}
      </div>
    </div>
  </section>
);

export default function Legal({ page }) {
  const p = LEGAL_PAGES[page];
  const other = page === "mentions-legales" ? { to: "/conditions-generales", label: "Conditions générales" } : { to: "/mentions-legales", label: "Mentions légales" };
  return (
    <>
      <PageHeader top={p.top} bottom={p.bottom} intro={p.intro} testId={`legal-header-${page}`} />
      <Container className="py-12 md:py-20">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-400" data-testid="legal-updated">Mis à jour le {p.updated}</p>
        <div data-testid={`legal-page-${page}`}>{p.sections.map((s, i) => <Section key={s.title} s={s} i={i} />)}</div>
        <Link to={other.to} className={`inline-block mt-10 text-xs uppercase tracking-[0.2em] font-bold ${linkCls}`} data-testid="legal-other-link">Voir aussi : {other.label}</Link>
      </Container>
    </>
  );
}
